<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <strong>Route Mapping Details</strong>
            </div>
            <div id="overlay" style="display: none;">
              <div class="loader"></div>
            </div>
            <b-row>
              <b-col md="5">
                <b-form-group label="Warehouse ID" :label-cols="3">
                  <div id='container'>
                      <ejs-multiselect  id='multi_select2'  placeholder="Select WareHouse" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                      ></ejs-multiselect>
                  </div>    
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label="Upload File" :label-cols="3">
                  <b-form-file
                    type="file" 
                    v-model="file"
                    :state="Boolean(file)"
                    @change="selectcsvFiletoUpload($event)"
                    placeholder="Upload CSV File" 
                    accept=".csv" required
                  ></b-form-file>
                </b-form-group>
                <!-- </b-col>
                      </b-row> -->
              </b-col>
              <b-col md="2">
                <b-row>
                  <b-col md="6">
                    <b-button
                      variant="primary"
                      :pressed.sync="myToggle"
                      @click="uploadcsv()"
                      >Submit</b-button
                    >
                  </b-col>
                  <b-col md="6">
                    <b-button variant="danger" @click="clearcsv()"
                      >Clear</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-4">
                <div style="border: 1px solid rgb(203 201 201);
                padding: 10px;">
                  <b-row>
                    <b-col md="12" class="text-left">
                      <b style="font-weight:bold; font-size:15px;    font-family: initial;"> Available Vehicle :- </b> &nbsp;&nbsp;<label>MH12SH6757, &nbsp; MH76VH8575</label>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col class="mt-2">
                <span class="B2D" style="background: rgb(146 187 223);
                padding: 4px 12px;"></span>&nbsp; B2D&nbsp;&nbsp;
                <span class="B2D" style="background: rgb(109 187 148);
                padding: 4px 12px;"></span>&nbsp; Franchies&nbsp;&nbsp;
                <!-- <span class="B2D" style="background: rgb(231 135 135); -->
                <!-- padding: 4px 12px;"></span>&nbsp; distributor&nbsp;&nbsp; -->
                <span class="B2D" style="background: rgb(213 182 127);
                padding: 4px 12px;"></span>&nbsp; Distributor&nbsp;&nbsp;
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col md="2">
                <b-card
                  class="mb-2 pending_remove"
                >
                  <b-card-text>
                    <h5 style="text-align: center;">Pending Load</h5>
                    <b-list-group>
                      <b-list-group-item style="background: rgb(146 187 223);">DF57F5785678</b-list-group-item>
                      <b-list-group-item  style="background: rgb(109 187 148);">D57655476VGH</b-list-group-item>
                      <b-list-group-item  style="background: rgb(109 187 148);">M65785VJGCV6</b-list-group-item>
                      <b-list-group-item style="background: rgb(146 187 223);">P457UVTF457Y</b-list-group-item>
                      <b-list-group-item style="background: rgb(213 182 127);">VE6T766RTVTR4</b-list-group-item>
                      <b-list-group-item style="background: rgb(213 182 127);" >DF57F5785678</b-list-group-item>
                      <b-list-group-item style="background: rgb(109 187 148);">D57655476VGH</b-list-group-item>
                      <b-list-group-item style="background: rgb(146 187 223);">M65785VJGCV6</b-list-group-item>
                      <b-list-group-item style="background: rgb(213 182 127);">P457UVTF457Y</b-list-group-item>
                      <b-list-group-item  style="background: rgb(109 187 148);">VE6T766RTVTR4</b-list-group-item>
                    </b-list-group>
                  </b-card-text>

                </b-card>
              </b-col>
              <b-col md="10" class="p-0">
                <b-card>
                  <b-card-text>
                    <b-tabs pills class="navtablist">
                      <b-tab title="Vehicle 1" active>
                        <b-card-text>
                          <b-row>
                            <b-col>
                              <label class="pl-2"> Total Volumetric Weight :- </label>
                            </b-col>
                            <b-col> 
                              <label> Available Vehicle :- </label>
                            </b-col>
                          </b-row>
                          <div style="overflow: scroll;">
                            <GmapMap
                            :center="center"
                            :zoom="20"
                            map-type-id="terrain"
                            style="width: 100%; height: 500px"
                            @click="addmaploction($event)"
                          >
                            <GmapMarker
                              :key="index"
                              v-for="(m, index) in markers"
                              :label="m.position.name.substring(1,0)"
                              :position="m.position"
                              :clickable="true"
                              :draggable="true"
                              @click="openWindow($event,index)"
                              v-b-tooltip.hover :title="m.position.name"
                            />
                            <!-- <gmap-polyline v-bind:path.sync="path" v-bind:options="{ strokecolor:'#008000'}">
                            </gmap-polyline> -->
                            <GmapPolyline
                            :path="paths"
                            :options="polylineOptions"
                           />
                           <gmap-info-window 
                              @closeclick="window_open=false" 
                              :opened="window_open" 
                              :position="infowindow"
                              :options="{
                                pixelOffset: {
                                  width: 0,
                                  height: -35
                                }
                              }"
                          >
                              {{formattedAddress}}
                              <br><br>
                              <div class="text-center p-2">
                                <b-button variant="danger" size="sm" @click="deleteGroup(index)"> Remove </b-button>
                              </div>
                              
                          </gmap-info-window>
                          <gmap-info-window 
                              @closeclick="addwindowclose" 
                              :opened="addwindow_open" 
                              :position="addinfowindow"
                              :options="{
                                pixelOffset: {
                                  width: 0,
                                  height: -30
                                }
                              }"
                          >
                          Are You Want To Add This Destination ( {{addformattedAddress}}) 
                              <br><br>
                              <div class="text-center p-2">
                                <b-button variant="success" size="sm" @click="addmapinfo()"> Add </b-button>
                              </div>
                              
                          </gmap-info-window>  
                          </GmapMap>

                          </div>
                        </b-card-text>
                        <div class="text-center">
                          <b-button squared variant="success" @click="GenerateRoute"> Generate Route </b-button>
                        </div>
                        
                      </b-tab>
                      <b-tab title="Vehicle 2">
                        <b-card-text>
                          <b-row>
                            <b-col>
                              <label> Total Volumetric Weight :- </label>
                            </b-col>
                            <b-col> 
                              <label> Available Vehicle :- </label>
                            </b-col>
                          </b-row>
                           <div style="overflow: scroll;">
                            <GmapMap
                            :center="{lat:10, lng:10}"
                            :zoom="7"
                            map-type-id="terrain"
                            style="width: 100%; height: 500px"
                          >
                            <GmapMarker
                              :key="index"
                              v-for="(m, index) in markers"
                              :position="m.position"
                              :clickable="true"
                              :draggable="true"
                              @click="center=m.position"
                            />
                          </GmapMap>
                          </div>
                        </b-card-text>
                      </b-tab>
                      <b-tab title="Vehicle 3">
                        <b-card-text>
                          <b-row>
                            <b-col>
                              <label> Total Volumetric Weight :- </label>
                            </b-col>
                            <b-col> 
                              <label> Available Vehicle :- </label>
                            </b-col>
                          </b-row>
                          <div style="overflow: scroll;">
                            <GmapMap
                            :center="{lat:10, lng:10}"
                            :zoom="7"
                            map-type-id="terrain"
                            style="width: 100%; height: 500px"
                          >
                            <GmapMarker
                              :key="index"
                              v-for="(m, index) in markers"
                              :position="m.position"
                              :clickable="true"
                              :draggable="true"
                              @click="center=m.position"
                            />
                          </GmapMap>
                          </div>
                        </b-card-text>
                      </b-tab>
                      <b-tab title="Vehicle 4">
                        <b-card-text>
                          <b-row>
                            <b-col>
                              <label> Total Volumetric Weight :- </label>
                            </b-col>
                            <b-col> 
                              <label> Available Vehicle :- </label>
                            </b-col>
                          </b-row>
                          <div style="overflow: scroll;">
                            <GmapMap
                            :center="{lat:10, lng:10}"
                            :zoom="7"
                            map-type-id="terrain"
                            style="width: 100%; height: 500px"
                          >
                            <GmapMarker
                              :key="index"
                              v-for="(m, index) in markers"
                              :position="m.position"
                              :clickable="true"
                              :draggable="true"
                              @click="center=m.position"
                            />
                          </GmapMap>
                          </div>
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card-text>
                </b-card>

              </b-col>
              <!-- <b-col md="2">
                <b-card
                  class="mb-2 pending_remove"
                >
                  <b-card-text>
                   <h5 style="text-align: center;">Remove Log</h5>
                   <b-list-group>
                    <b-list-group-item>DF57F5785678</b-list-group-item>
                    <b-list-group-item>D57655476VGH</b-list-group-item>
                    <b-list-group-item>M65785VJGCV6</b-list-group-item>
                    <b-list-group-item>P457UVTF457Y</b-list-group-item>
                    <b-list-group-item>VE6T766RTVTR4</b-list-group-item>
                    <b-list-group-item>DF57F5785678</b-list-group-item>
                    <b-list-group-item>D57655476VGH</b-list-group-item>
                    <b-list-group-item>M65785VJGCV6</b-list-group-item>
                    <b-list-group-item>P457UVTF457Y</b-list-group-item>
                    <b-list-group-item>VE6T766RTVTR4</b-list-group-item>
                  </b-list-group>
                  </b-card-text>

                </b-card>
              </b-col> -->
            </b-row>
            
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from "vue";
  export default {
    data() {
      return {
        selectcsvFile: "",
        file: "",
        selectFiletype: "",
        optionsWH :[
        {
            "warehouseid": "12876",
            "warehousename": "DcMAK",
            "fcsourceid": "12876"
        },
        {
            "warehouseid": "1429",
            "warehousename": "Harsh Baby Care",
            "fcsourceid": "1429"
        },
        {
            "warehouseid": "183",
            "warehousename": "SRI BALAJI ENTERPRISE",
            "fcsourceid": "183"
        },
        {
            "warehouseid": "1837",
            "warehousename": "MRPL",
            "fcsourceid": "1837"
        },
        {
            "warehouseid": "1895",
            "warehousename": "Atlantic Trading Company",
            "fcsourceid": "1895"
        },
        {
            "warehouseid": "1901",
            "warehousename": "Prasaads Baby Collection",
            "fcsourceid": "1901"
        },
        {
            "warehouseid": "1956",
            "warehousename": "GoPeppy",
            "fcsourceid": "1956"
        },
        {
            "warehouseid": "3251",
            "warehousename": "Unique Concepts",
            "fcsourceid": "3251"
        },
        {
            "warehouseid": "3460",
            "warehousename": "Siddhivinayak Medical",
            "fcsourceid": "3460"
        },
        {
            "warehouseid": "3976",
            "warehousename": "Anil Medicose",
            "fcsourceid": "3976"
        },
        {
            "warehouseid": "3984",
            "warehousename": "Maruti Enterprise",
            "fcsourceid": "3984"
        }
        ],
        valueWH :[],
        fieldWH:{ text: 'warehousename', value: 'warehouseid' },
        center: { lat: 0, lng: 0 }, // Initial map center
        zoom: 12, // Initial zoom level
        mapPlotting :[
            {
                "tripid": "1307",
                "checkinpoints": "1, Matoshree Ramabai Ambedkar Rd, Siddharth Nagar Tadiwala Road, Tadiwala Road, Pune, Maharashtra 411001, India",
                "createdate": "2023-09-06 13:00:48",
                "distance": 0,
                "sysusermasterid": "5af91461-9c9a-425e-b6c2-017f898e4bf4",
                "ridername": "jliiSE SE",
                "location": {
                    "x": 18.5331096,
                    "y": 73.874149
                },
                "push_flag": "1",
                "googlerror": null,
                "ischeckin": "YES",
                "checkin_type": "CAPTURED",
                "checkin_position_sequence": 1
            },
            {
                "tripid": "1307",
                "checkinpoints": "Demo ",
                "createdate": "2023-09-06 13:01:45",
                "distance": 0.055,
                "sysusermasterid": "5af91461-9c9a-425e-b6c2-017f898e4bf4",
                "ridername": "jliiSE SE",
                "location": {
                    "x": 18.5326008,
                    "y": 73.8738954
                },
                "push_flag": "1",
                "googlerror": "",
                "ischeckin": "YES",
                "checkin_type": "CAPTURED",
                "checkin_position_sequence": 2
            },
            {
                "tripid": "1307",
                "checkinpoints": "Office No. 1, Ground floor, Kumar Garima, Tadiwala Rd, Sangamvadi, Pune, Maharashtra 411001, India",
                "createdate": "2023-09-06 13:04:05",
                "distance": 0.033,
                "sysusermasterid": "5af91461-9c9a-425e-b6c2-017f898e4bf4",
                "ridername": "jliiSE SE",
                "location": {
                    "x": 18.5329495,
                    "y": 73.8742839
                },
                "push_flag": "0",
                "googlerror": null,
                "ischeckin": "YES",
                "checkin_type": "CAPTURED",
                "checkin_position_sequence": 3
            },
            {
                "tripid": "1306",
                "checkinpoints": "Office ",
                "createdate": "2023-09-06 09:35:13",
                "distance": 0.099,
                "sysusermasterid": "804697f1-d3f7-4cd2-8531-c6e5ea3633ae",
                "ridername": "jliiASM ASM",
                "location": {
                    "x": 18.53294956,
                    "y": 73.8747868
                },
                "push_flag": "1",
                "googlerror": "",
                "ischeckin": "YES",
                "checkin_type": "CAPTURED",
                "checkin_position_sequence": 3
            },
            {
                "tripid": "1306",
                "checkinpoints": "Office ",
                "createdate": "2023-09-06 09:35:13",
                "distance": 0.012,
                "sysusermasterid": "804697f1-d3f7-4cd2-8531-c6e5ea3633ae",
                "ridername": "jliiASM ASM",
                "location": {
                    "x": 18.5290605,
                    "y": 73.8725515
                },
                "push_flag": "1",
                "googlerror": "",
                "ischeckin": "YES",
                "checkin_type": "CAPTURED",
                "checkin_position_sequence": 3
            },

        ],
        markers :[],
        paths:[],
        polylineOptions: {
          strokeColor: '#FF0000', // Customize the polyline color
          strokeOpacity: 1.0,
          strokeWeight: 1,
        },
        infowindow: [],
        window_open: false,
        info_marker: null,
        formattedAddress :'',
        addinfowindow :[],
        addformattedAddress :'',
        addwindow_open: false,
      };
      
    },
  
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.getchekLatLong()
    },

    methods: {
      GenerateRoute(){
        document.getElementById('generate_route').style.display ="block";
      },
      addmaploction(event){
        console.log("event",event)
        console.log("event.latLng.lat()",event.latLng.lat())
               console.log("event.latLng.lng()",event.latLng.lng())
        let value = event;
        const clicklatlng = value.latLng;
        this.addinfowindow = clicklatlng;
        console.log("valueclick",this.addinfowindow.lat.Scopes)
          // Use the Google Maps Geocoder to get the address
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({ location: clicklatlng }, (results, status) => {
            if (status === 'OK') {
              if (results[0]) {
                // Get the formatted address from the results and display it
                this.addformattedAddress = results[0].formatted_address;
                console.log("addformattedAddress",this.addformattedAddress)
                // Update your component's data with the address
                // For example: this.address = formattedAddress;
                this.addinfo = {
                    "tripid": "1307",
                    "checkinpoints":  this.addformattedAddress,
                    "createdate": "2023-09-06 09:35:13",
                    "distance": 0.012,
                    "sysusermasterid": "804697f1-d3f7-4cd2-8531-c6e5ea3633ae",
                    "ridername": "jliiASM",
                    "location": {
                        "x": clicklatlng.lat(),
                        "y": clicklatlng.lng()
                        
                    },
                    "push_flag": "1",
                    "googlerror": "",
                    "ischeckin": "YES",
                    "checkin_type": "CAPTURED",
                    "checkin_position_sequence": 3
                }
                this.addwindow_open = true;

              } else {
                console.error('No address found');
              }
            } else {
              console.error('Geocoder failed due to: ' + status);
            }
          });
      },

      addwindowclose(){
        this.addinfo ={};
        this.addwindow_open = false;
      },

      addmapinfo(){
        this.mapPlotting.push(this.addinfo);
        this.getchekLatLong();
        this.addwindow_open = false;
      },

      deleteGroup(){
        console.log("index",this.index_count)
        if (this.index_count == 0) {
          this.$fire({
                  text: "This is Source",
                  type: "error",
                  timer: 30000,
                });
                this.window_open= false;
                return false
        } else {
          this.mapPlotting.splice( this.index_count, 1);
          console.log("this.mapPlotting",this.mapPlotting)
          this.getchekLatLong();
          this.window_open= false;
        }
       
      },

      openWindow (event,index) {
        this.index_count = index;
            console.log(this);
            this.window_open = true;

             // Handle the click event to display the address popup
          const latlng = event.latLng;

          this.infowindow = latlng;
          // Use the Google Maps Geocoder to get the address
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === 'OK') {
              if (results[0]) {
                // Get the formatted address from the results and display it
                this.formattedAddress = results[0].formatted_address;
                console.log("formattedAddress",this.formattedAddress)
                // Update your component's data with the address
                // For example: this.address = formattedAddress;
              } else {
                console.error('No address found');
              }
            } else {
              console.error('Geocoder failed due to: ' + status);
            }
          });
      },

      selectcsvFiletoUpload: function(event) {
        this.selectcsvFile = event.target.files[0];
  
        this.selectFiletype = event.target.files[0].type;
      },


      uploadcsv: function() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        document.getElementById("overlay").style.display = "block";
        
        if (this.selectcsvFile=="") {
          this.$fire({
                  text: "Please Upload CSV",
                  type: "error",
                  timer: 30000,
                });
                document.getElementById("overlay").style.display = "none";
                return false
        } 
        else {
          if (this.selectFiletype == "text/csv") {
            document.getElementById("overlay").style.display = "none";
            this.$fire({
              text: "File Uploaded Successfully",
              type: "success",
              timer: 30000,
            });
            this.file ='';
          }
          else{
              document.getElementById("overlay").style.display = "none";
            this.file ='';
            this.$fire({
                        text:"Please Upload CSV File Only",
                        type: "error",
                        timer: 30000
                    }); 
            }
        }
      },
  
      clearcsv: function() {
        this.selectcsvFile = "";
        this.selectFiletype = "";
        this.file = "";
      },

      getchekLatLong(){
        this.markers = this.mapPlotting.map((coord,index)=>{
          console.log(coord)
          console.log("YYYYCheckYYYYY",coord.location.x ,coord.location.y);
          return {
            position: {
              lat: coord.location.x,
              lng: coord.location.y,
              name:index==0?'Source':'Destination'
            }
          };
        });

        // Initial map center coordinates
        let center={
          lat:this.markers[0].position.lat,
          lng:this.markers[0].position.lng
        }
        
        this.center=center;
        this.paths = this.markers.map(path => ({
          lat: path.position.lat,
          lng: path.position.lng
        }));
      }
    },
  };
  </script>
  <style>
  .tab-content .tab-pane {
      padding: 13px 0px;
  }
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }
  
  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }
  
 
  .routetable th,
  td {
    text-align: center;
  }
  .route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
  }
  #overlay {
    position: fixed; /* Sit on top of the page content */
    /*display: none;*/ /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
    .loader {
    position: fixed;;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 50px;
    height: 50px;
    left:50%;
    top:50%;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
   
  } 
  .loading{
     position: relative;
   
    width: 50px;
    height: 50px;
    left:50%;
    top:56%;
  }
  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .navtablist .nav{
    padding: 10px 0px;
    font-size: 16px;
    font-family: inherit;
  }
  .pending_remove .card-body{
    padding: 10px 0px 0px;
  }
  .list-group-item {
    padding: 5px;
    text-align: center;
    border-radius: 0px;
    border-left: unset;
    border-right: unset;
    color: #0c0808;
  }
  .list-group-item:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
  </style>
  